import PropTypes from 'prop-types';

// material-ui
import { styled } from '@mui/material/styles';
import {
  // Avatar,
  Card,
  CardContent,
  Grid,
  LinearProgress,
  // ListItem,
  // ListItemAvatar,
  // ListItemText,
  Typography,
  linearProgressClasses
} from '@mui/material';
import Avatar from 'ui-component/extended/Avatar';
import { useLocation } from 'react-router';
import {useState,useEffect} from 'react'
import { Stack } from '@mui/system';
import { ImageUploadapi } from '../../../../Axios/ServiceApi';
// assets
// import IconBrandSpeedtest from '@mui/icons-material/TableChartOutlined';

// styles
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 30,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: '#fff'
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.primary.main
  }
}));

const CardStyle = styled(Card)(( ) => ({
  background:"#fff",
  marginBottom: '22px',
  overflow: 'hidden',
  position: 'relative',
 
}));

// ==============================|| PROGRESS BAR WITH LABEL ||============================== //

function LinearProgressWithLabel({ value, ...others }) {
  // const theme = useTheme();

  return (
    <Grid container direction="column" spacing={1}>
      <Grid item>
        <Grid container justifyContent="space-between">
          <Grid item>
            {/* <Typography variant="h6" sx={{ color: theme.palette.primary[800] }}>
              Progress
            </Typography> */}
          </Grid>
          <Grid item>
            <Typography variant="h6" color="inherit">{`${Math.round(value)}%`}</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <BorderLinearProgress variant="determinate" value={value} {...others} />
      </Grid>
    </Grid>
  );
}

LinearProgressWithLabel.propTypes = {
  value: PropTypes.number
};

// ==============================|| SIDEBAR MENU Card ||============================== //

const MenuCard = () => {
  
  const [location,setLocation]=useState(null)
  const [profilrPic,setProfilePic]=useState(null)
  let params=useLocation()
  useEffect(() => {
    setLocation(params.pathname)
    ImageUploadapi(setProfilePic)
  }, [params])
  

  return (
    <CardStyle sx={{display:location==="/product/dashboard"?'none':'none'}}>
      <CardContent sx={{ p: 2 }}>
        <Stack sx={{ p: 0, m: 0 ,display:'flex',direction:'column',justifyContent:'center',alignItems:'center'}}>
          <Avatar 
          size={10}
          sx={{ width: 150, height: 150 }}
          src={profilrPic}

          />
          <Typography mt={2} variant="h4" sx={{ color: "#252525" }}>
           {sessionStorage.getItem('fname')}
          </Typography>
        </Stack>
      </CardContent>
    </CardStyle>
  );
};

export default MenuCard;
